import React from 'react';
import Axios from 'axios';
//import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client';
import MenuProfile from './menuProfile';
import ShopProfile from './shopProfile';
import '../mainCSS/mobile-menu.css';

export default class MobileMenu extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            main: [],
            sub: [],
            stat: [],
            listRoot: null
        }
    }

    componentDidMount() {
        var url = ShopProfile.getURL() + '/index/reactFetch.php';
        var data = new URLSearchParams({
            event: 'menu-data',
            reverse: false
        });
        Axios.post(url, data)
            .then(res => {
                this.setState({
                    main: res.data['main'],
                    sub: res.data['sub'],
                    stat: res.data['stat']
                })
                MenuProfile.setMainMenu(Object.values(res.data['main']));
                MenuProfile.setSubMenu(Object.values(res.data['sub']));
                MenuProfile.setStatMenu(res.data['stat']);
            })
    }

    subMenuCompiles(name) {
        var res = [];
        var item = [];
        var x = 0;
        var data = MenuProfile.getSubMenu();
        for (var i = 0; i < data.length; i++) {
            if (data[i].main === name) {
                item['id'] = data[i].id;
                item['name'] = data[i].name;
                item['link'] = data[i].link;
                res[x] = Object.assign({}, item);
                x++;
            }
        }
        return res;
    }

    menuListHead(sub) {
        return (
            <li>
                {sub === 'sub' ? <span onClick={() => this.menuListShow('m-category')} className='fa head-left'></span> : ''}
                <span onClick={() => this.menuListClose()} className='fa head-right'></span>
            </li>
        )
    }

    menuListClose() {
        /*var { listRoot } = this.state;
        setTimeout(function () {
            listRoot.render(<ul></ul>);
        }, 10);*/
        document.getElementById('m-listitem').style.display = 'none';
    }

    menuListShow(name) {
        var { listRoot } = this.state;
        if (listRoot == null) {
            listRoot = createRoot(document.getElementById('m-listitem'));
            this.setState({ listRoot: listRoot })
        }
        document.getElementById('m-listitem').style.display = 'none';
        var data = '';
        var sub = '';
        if (name === 'm-category') {
            data = MenuProfile.getMainMenu();
        } else if (name === 'm-menu') {
            data = MenuProfile.getStatMenu();
        } else {
            data = this.subMenuCompiles(name);
            sub = 'sub';
        }
        const res = data.map((d) =>
            <li key={d.id}>
                <p onClick={() => this.menuLink(d.link)}><a href={ShopProfile.getURL() + '/' + d.link}>{d.name}</a></p>
                {d.sub !== "undefined" && d.sub > 0 ? <span onClick={() => this.menuListShow(d.name)}><i>{d.sub}</i></span> : ''}
            </li>
        );
        var menuListHead = this.menuListHead(sub);
        setTimeout(function () {
            listRoot.render(<ul>{menuListHead}{res}</ul>);
        }, 10);
        document.getElementById('m-listitem').style.display = 'block';
    }

    menu(name, title) {
        return (
            <div id={name} onClick={() => this.menuListShow(name)}>
                <span> </span>
                <span> </span>
                <span> </span>
                <p>{title}</p>
            </div>
        )
    }

    basketLoad() {
        window.basketload();
    }

    menuLink(link) {
        document.location.href = ShopProfile.getURL() + '/' + link;
    }

    render() {
        var data = MenuProfile.getMainMenu();
        const res = data.map((d) =>
            <li key={d.id}>
                <p onClick={() => this.menuLink(d.link)}><a href={ShopProfile.getURL() + '/' + d.link}>{d.name}</a></p>
                {d.sub !== "undefined" && d.sub > 0 ? <span onClick={() => this.menuListShow(d.name)}><i>{d.sub}</i></span> : ''}
            </li>
        );
        var mMenu = this.menu("m-menu", "Információ");
        var mCategory = this.menu("m-category", "Termékek");
        return (
            <div>
                {mMenu}
                <span onClick={() => this.basketLoad()}>
                    <i className='fa cart'></i>
                </span>
                {mCategory}
                <div id='m-listitem'>{res}</div>
            </div>
        )
    }

}